import { render, staticRenderFns } from "./IpImport.vue?vue&type=template&id=d2597f50"
import script from "./IpImport.vue?vue&type=script&lang=js"
export * from "./IpImport.vue?vue&type=script&lang=js"
import style0 from "./IpImport.vue?vue&type=style&index=0&id=d2597f50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports